import { render, staticRenderFns } from "./StatusSelector.vue?vue&type=template&id=5c8e5c76&scoped=true&"
import script from "./StatusSelector.vue?vue&type=script&lang=js&"
export * from "./StatusSelector.vue?vue&type=script&lang=js&"
import style0 from "./StatusSelector.vue?vue&type=style&index=0&id=5c8e5c76&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8e5c76",
  null
  
)

export default component.exports